import { Helmet } from "react-helmet";

const GoogleAnalytics = () => {
  return (
    <Helmet>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-QP6YY1XMBV"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-QP6YY1XMBV');
        `}
      </script>
    </Helmet>
  );
};

export default GoogleAnalytics;
